import { MFA_COMPLETED } from '@/features/mfa/constants';
import {
  selectIsMfaSignInLoading,
  selectIsMfaSkipped,
  selectMfaStatus
} from '@/features/mfa/selectors';
import { selectHasDevices } from '@/features/mfaDevices/selectors';
import { selectIsLoggedIn } from '@/features/user/selectors';

import { createSelector } from '@reduxjs/toolkit';
import { prop } from 'ramda';

export const selectRedirectUrlRoot = prop('redirectUrl');
export const selectRedirectUrl = createSelector(selectRedirectUrlRoot, prop('url'));

export const selectShouldRedirect = createSelector(
  [
    selectIsLoggedIn,
    selectIsMfaSkipped,
    selectHasDevices,
    selectMfaStatus,
    selectIsMfaSignInLoading
  ],
  (isLoggedIn, shouldSkipMfa, hasDevices, mfaStatus, isMfaLoading) => {
    return (
      !isMfaLoading && isLoggedIn && (shouldSkipMfa || (hasDevices && mfaStatus === MFA_COMPLETED))
    );
  }
);
